import React, { useState } from "react";
import client from "../lib/api";
import { Button } from "./ui/button";
import { Mail, Eye, Loader2, Trophy, Clock, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { tr } from "../i18n/LangContext";

export const DigestCard = () => {
  const [sending, setSending] = useState(false);
  const [preview, setPreview] = useState(null);

  const sendMe = async () => {
    setSending(true);
    try { const r = await client.post("/digest/weekly/send-me"); toast.success("Digest sent", { description: `Check ${r.data.to}` }); }
    catch (e) { toast.error("Couldn't send", { description: e?.response?.data?.detail }); }
    finally { setSending(false); }
  };
  const load = async () => {
    try { const r = await client.get("/digest/weekly/preview"); setPreview(r.data); }
    catch (e) { toast.error("Couldn't build the preview"); }
  };

  return (
    <div className="glass rounded-2xl p-6" data-testid="digest-card">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h3 className="flex items-center gap-2 font-display text-lg font-semibold text-white"><Mail className="h-4 w-4 text-brand-green" /> {tr("Weekly sourcing digest")}</h3>
          <p className="mt-1 max-w-lg text-sm text-muted-foreground">{tr("Every Monday at 8am UK time you get one email: your Top 5, deals that haven't moved in two weeks, and Claude's sourcing rules from the latest disqualified-deals review.")}</p>
        </div>
        <div className="flex shrink-0 gap-2">
          <Button variant="outline" onClick={load} data-testid="digest-preview-btn" className="h-10 border-white/12 bg-white/[0.03] text-white hover:bg-white/[0.07]"><Eye className="h-4 w-4" /> {tr("Preview")}</Button>
          <Button onClick={sendMe} disabled={sending} data-testid="digest-send-btn" className="h-10 bg-brand-green text-white hover:bg-brand-green/90">{sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />} {tr("Email me now")}</Button>
        </div>
      </div>
      {preview && (
        <div className="mt-5 grid gap-4 sm:grid-cols-3" data-testid="digest-preview">
          <div className="rounded-xl border border-amber-400/20 bg-amber-400/[0.05] p-4">
            <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-amber-300"><Trophy className="h-3.5 w-3.5" /> Top 5</p>
            {preview.top.length ? preview.top.map((p) => <p key={p.id} className="mt-1.5 truncate text-sm text-white"><span className="text-amber-300">#{p.rank}</span> {p.title}</p>) : <p className="mt-1.5 text-sm text-muted-foreground">Nothing ranked yet</p>}
          </div>
          <div className="rounded-xl border border-brand-red/20 bg-brand-red/[0.05] p-4">
            <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-brand-red"><Clock className="h-3.5 w-3.5" /> Stalled 14d+</p>
            {preview.stalled.length ? preview.stalled.map((p) => <p key={p.id} className="mt-1.5 truncate text-sm text-white">{p.title} <span className="text-muted-foreground">· {p.days_stalled}d</span></p>) : <p className="mt-1.5 text-sm text-muted-foreground">Nothing stuck</p>}
          </div>
          <div className="rounded-xl border border-brand-green/20 bg-brand-green/[0.05] p-4">
            <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-brand-green"><Sparkles className="h-3.5 w-3.5" /> Sourcing rules</p>
            <p className="mt-1.5 text-sm text-muted-foreground">{preview.rules ? `From Claude's ${preview.rules.month} review` : "Run “Summarise the month” on AI Insights to fill this"}</p>
          </div>
        </div>
      )}
    </div>
  );
};
